export default {
    ABOUT: '/about',
    AGENTS: '/agents',
    AGENTS_FORM: '/agents/form',
    CAREERS: '/careers',
    ERROR: '/error',
    HEX: '/hex',
    HOMEPAGE: '/',
    JOIN: '/join',
    LEGAL: '/legal',
    LICENSES: '/licenses',
    LIENHOLDER_SUPPORT: '/lienholder-support',
    OLD_PRIVACY_POLICY: '/old-privacy-policy',
    PAY: '/pay',
    PLANS: '/plans',
    PRIVACY_FORM: '/privacy-form',
    REVIEWS: '/reviews',
};
